// CommitChart.js
import {Line, mixins} from 'vue-chartjs'

let reactiveProp = mixins.reactiveProp;


export default {
  name: 'fitbit-sleep-chart',
  extends: Line,
  mixins: [reactiveProp],
  props: ['options'],
  data() {
    return {}
  },
  mounted() {
    let self = this;

    self.renderChart(self.chartData, self.options);


    let chart = this.$data._chart;
    let metaData = chart.config.data.datasets[0]._meta;
    let arbitraryKey = Object.keys(metaData);

    let chartMetaDatas = metaData[arbitraryKey].data;


    for (let i = 0; i < chartMetaDatas.length; i++) {
      chartMetaDatas[i]._view.backgroundColor = 'green';
    }


    chart.update();

  }
}



// WEBPACK FOOTER //
// ./src/components/Tracking/Graph/FitBitSleep/index.js